<template>
    <div class="text-center p-5">
        <spinner size="lg"/>
        <p class="text-muted small">Loading Results</p>
    </div>
    <marquis-intro-boxes class="my-5"/>
</template>

<script type="text/javascript">
    import MarquisIntroBoxes from '@/components/Content/Public/Home/Guests/MarquisIntroBoxes.vue';
    import CommonComponents from '@/components/Common.vue';


    export default {
        components: {
            MarquisIntroBoxes,
            ...CommonComponents,
        },
    };

</script>
